import { Form, Input, InputNumber, Radio, Select } from "antd";
import { operatorType } from "../const";
import { useEffect } from "react";

export const Refund = ({ form, record, amount }: any) => {
  useEffect(() => {
    if (record?.id) {
      form.setFieldsValue({
        orderNo: record?.orderNo,
      });
    }
  }, [record]);

  return (
    <Form
      form={form}
      size="small"
      name="RefundForm"
      className='refund-form'
      labelCol={{ span: 7 }}
      wrapperCol={{ span: 16 }}
      autoComplete="off"
    >
      <Form.Item label="密码" name="pwd" rules={[{ required: true, message: '不能为空' }]}>
        <Input.Password placeholder="请输入密码" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item label="订单号" name="orderNo" rules={[{ required: true, message: '不能为空' }]}>
        <Input placeholder="请输入订单号" disabled={amount >= 0} />
      </Form.Item>
      <Form.Item label="退款金额" name="totalAmount" rules={[{ required: true, message: '不能为空' }]}>
        <InputNumber
          min={0}
          max={amount}
          placeholder="请输入退款金额"
          precision={2}
          style={{ width: '100%' }}
          addonAfter={'元'}
        />
      </Form.Item>
      <Form.Item label="业务类型" name="businessType"
        initialValue="VIP" rules={[{ required: true, message: '不能为空' }]}>
        <Select
          options={Object.entries(operatorType).map(([key, value]) => ({
            label: value.text,
            value: key,
          }))}
        />
      </Form.Item>
      <Form.Item label="退款原因" name="reason">
        <Input.TextArea placeholder="输入退款原因" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item label="是否执行退款" name="realRefundFlag" initialValue={false} rules={[{ required: true, message: '不能为空' }]}>
        <Radio.Group style={{ width: '100%' }}>
          <Radio value={true}>是</Radio>
          <Radio value={false}>否</Radio>
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};
